import { render, staticRenderFns } from "./SubjectConsumptionTable.vue?vue&type=template&id=1992c7aa&scoped=true"
import script from "./SubjectConsumptionTable.vue?vue&type=script&lang=js"
export * from "./SubjectConsumptionTable.vue?vue&type=script&lang=js"
import style0 from "./SubjectConsumptionTable.vue?vue&type=style&index=0&id=1992c7aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1992c7aa",
  null
  
)

export default component.exports